import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const DesignSettingIcon: React.FC<IconProps> = ({
  isActive = false,
  ...props
}) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.33333 0C12.9358 0 16.6667 3.73083 16.6667 8.33333C16.6656 8.875 16.6156 9.40278 16.5167 9.91667C16.195 11.5867 14.5192 12.2917 13.115 12.0583L11.665 11.8167C11.4963 11.7885 11.3233 11.8011 11.1603 11.8533C10.9974 11.9054 10.8493 11.9957 10.7283 12.1167C10.42 12.425 10.2725 12.8492 10.48 13.2633C10.8325 13.9683 10.8375 14.7733 10.5258 15.4325C10.1092 16.3167 9.25833 16.6667 8.33333 16.6667C3.73083 16.6667 0 12.9358 0 8.33333C0 3.73083 3.73083 0 8.33333 0ZM8.33333 1.66667C6.56522 1.66667 4.86953 2.36905 3.61929 3.61929C2.36905 4.86953 1.66667 6.56522 1.66667 8.33333C1.66667 10.1014 2.36905 11.7971 3.61929 13.0474C4.86953 14.2976 6.56522 15 8.33333 15L8.49583 14.9983C8.71083 14.99 8.9125 14.9483 9.01917 14.7217C9.0672 14.6081 9.08942 14.4853 9.08423 14.362C9.07905 14.2388 9.04658 14.1183 8.98917 14.0092C8.46417 12.9575 8.7375 11.7508 9.55 10.9383C9.85855 10.6298 10.2363 10.3993 10.6518 10.2661C11.0674 10.1329 11.5087 10.1008 11.9392 10.1725L13.3892 10.4142C14.1867 10.5475 14.7792 10.1242 14.88 9.60167C15.067 8.63649 15.0383 7.64189 14.7958 6.68913C14.5534 5.73636 14.1032 4.84902 13.4775 4.09067C12.8518 3.33232 12.0662 2.72174 11.1768 2.30266C10.2875 1.88359 9.31647 1.66641 8.33333 1.66667ZM4.58333 7.5C4.74749 7.5 4.91003 7.53233 5.06169 7.59515C5.21335 7.65797 5.35114 7.75004 5.46722 7.86612C5.58329 7.98219 5.67536 8.11999 5.73818 8.27165C5.801 8.4233 5.83333 8.58585 5.83333 8.75C5.83333 8.91415 5.801 9.0767 5.73818 9.22835C5.67536 9.38001 5.58329 9.51781 5.46722 9.63388C5.35114 9.74996 5.21335 9.84203 5.06169 9.90485C4.91003 9.96767 4.74749 10 4.58333 10C4.25181 10 3.93387 9.8683 3.69945 9.63388C3.46503 9.39946 3.33333 9.08152 3.33333 8.75C3.33333 8.41848 3.46503 8.10054 3.69945 7.86612C3.93387 7.6317 4.25181 7.5 4.58333 7.5ZM10.4167 4.16667C10.7482 4.16667 11.0661 4.29836 11.3006 4.53278C11.535 4.7672 11.6667 5.08515 11.6667 5.41667C11.6667 5.74819 11.535 6.06613 11.3006 6.30055C11.0661 6.53497 10.7482 6.66667 10.4167 6.66667C10.0851 6.66667 9.7672 6.53497 9.53278 6.30055C9.29836 6.06613 9.16667 5.74819 9.16667 5.41667C9.16667 5.08515 9.29836 4.7672 9.53278 4.53278C9.7672 4.29836 10.0851 4.16667 10.4167 4.16667ZM6.25 4.16667C6.58152 4.16667 6.89946 4.29836 7.13388 4.53278C7.3683 4.7672 7.5 5.08515 7.5 5.41667C7.5 5.74819 7.3683 6.06613 7.13388 6.30055C6.89946 6.53497 6.58152 6.66667 6.25 6.66667C5.91848 6.66667 5.60054 6.53497 5.36612 6.30055C5.1317 6.06613 5 5.74819 5 5.41667C5 5.08515 5.1317 4.7672 5.36612 4.53278C5.60054 4.29836 5.91848 4.16667 6.25 4.16667Z"
      fill={isActive ? 'url(#gradient)' : '#333333'}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0"
          y1="8.33333"
          x2="16.4847"
          y2="6.60155"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default DesignSettingIcon;
